import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from 'react-leaflet';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { UpdatePillar, UpdatePillarCoordinate, UpdateWellCoordinate } from '../../../UpdateData/UpdateCommunications';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import { PILLAR, WELL } from '../../../Constants/ConstantsOptics';

const ChangeCoordManuallyDialog = ({ open, onClose, id, user, cantonRefresh, flag }) => {
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const initialCoordinates = ''; 
  const [coordinates, setCoordinates] = useState(initialCoordinates); 
 
  const handleInputChange = (e) => {
    setCoordinates(e.target.value || ''); 
  };

  const changeCoordinate = () => {
    const coords = coordinates.split(',').map(coord => parseFloat(coord.trim()));    
    if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
      if(flag === WELL){
        UpdateWellCoordinate(id, coords[0], coords[1], user, cantonRefresh);
        showSnackbar(`Колодец. Изменения внесены!`, 'snackbarWarning');
      }else if(flag === PILLAR){
        UpdatePillarCoordinate(id, coords[0], coords[1], user, cantonRefresh);
        showSnackbar(`Опора. Изменения внесены!`, 'snackbarWarning');
      }
     
    } else {
      showSnackbar(`Введите корректные координаты в формате "50.4488, 30.5255"!`, 'snackbarWarning');
    }
  };

  // Обработчик закрытия окна
  const handleClose = () => { 
    setCoordinates('');  
    onClose();
  };

  return (
    <Dialog open={open} className="modalStyleUpTer">
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Обновление координат вручную</label>
        <hr className='horizontalLineModalUpTer' />
        <input 
          className='inputAuth'
          type="text"
          placeholder="формат 50.4488, 30.5255" 
          value={coordinates} 
          onChange={handleInputChange}
          style={{width: '300px'}}
        />       
        <button onClick={changeCoordinate} className='buttonIsHideModalUpTer' style={{ marginBottom: '10px', padding: "10px" }}>
          Изменить
        </button>   
        <hr className='horizontalLineModalUpTer' />
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose} class='buttonIsHideModalUpTer'>
          Закрыть
        </Button>
      </DialogActions>
       {/* Snackbar */}
       <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? 'orange' : 'orange'
            }
          }}
        />
    </Dialog>
  );
};

export default ChangeCoordManuallyDialog;